<template>
  <div class="moow-master-container">
    <b-container>
      <b-row>
        <b-col sm="12" lg="8">
          <div class="align-rel-container">
            <md-card md-with-hover class="vert-cent">
              <md-card-content>
                <p class="moow-header">Latest feature releases</p>
                <!-- <p class="moow-info-txt"> -->
                <ul>
                     <li><p class="moow-info-txt">Calendar - manage your vacanies and bookings in one place</p></li>
                  <li><p class="moow-info-txt">Add videos to your listings (go to Preview or Edit view)</p></li>
                  <li><p class="moow-info-txt">Log in via a popup in Preview</p></li>
                  <li><p class="moow-info-txt">Clone a Property when inputing similar objects</p></li>
                  <li><p class="moow-info-txt">Moowle AutoPrice now with you in Edit and Add view</p></li>
                  <li><p class="moow-info-txt">Traverse the history of Deal changes via snapshots</p></li>
                  <li><p class="moow-info-txt">Added identity management system</p></li>
                  <li><p class="moow-info-txt">Added Account and Property based legal structure</p></li>
                  <li><p class="moow-info-txt">Powerful analytics engine shows views on your listing and where they originate, even in external portals</p></li>
                </ul>
              </md-card-content>
              <md-card-actions>
                <md-button @click="home()" class="md-primary play-cta-button makeup">Go To Dashboard</md-button>
              </md-card-actions>
            </md-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  updated() {},
  methods: {
    home() {
      this.changeView("dashboard");
    },
    changeView(name, params) {
      this.$router.push({
        name: name,
        params: params
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

h1 {
  font-size: 10em;
}

.total-center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Changelog.vue